import { render, staticRenderFns } from "./TextTip.vue?vue&type=template&id=fbf39f80&scoped=true"
import script from "./TextTip.vue?vue&type=script&lang=js"
export * from "./TextTip.vue?vue&type=script&lang=js"
import style0 from "./TextTip.vue?vue&type=style&index=0&id=fbf39f80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf39f80",
  null
  
)

export default component.exports